<template>
    <div>
        <section v-if="getOrderData">
            <div class="container">

                <div class="text-title">Order Details</div>
                <order-details-info :order="getOrderData" />

                <div class="text-subtitle">Order Items</div>
                <q-card class="q-mt-sm">
                    <q-card-section>
                        <div class="row q-col-gutter-x-md">
                            <div class="col-xs-12 col-md-8">
                                <div class="row items-center q-mb-md q-py-sm q-px-md rounded-borders bg-grey-2"
                                     v-for="detail in getOrderData.orderDetails" :key="detail.product">

                                    <div class="col-xs-12 col-sm-7 q-pb-md q-pr-sm">
                                        <div class="text-subtitle2">{{ detail.productDescription }}</div>
                                        <q-field v-if="detail.installationID"
                                                 dense readonly
                                                 label="Install ID"
                                                 class="full-width"
                                                 stack-label>
                                            <template v-slot:control>
                                                <div class="self-center full-width no-outline text-caption">{{ detail.installationID }}</div>
                                            </template>
                                        </q-field>
                                        <q-field v-if="detail.discountCode"
                                                 dense readonly
                                                 label="Discount Code"
                                                 class="full-width"
                                                 stack-label>
                                            <template v-slot:control>
                                                <div class="self-center full-width no-outline text-caption">{{ detail.discountCode }}</div>
                                            </template>
                                        </q-field>
                                    </div>
                                    <div class="col-xs-4 col-sm-2 text-center">

                                        <q-field dense borderless readonly
                                                 class="full-width"
                                                 label="Qty" stack-label>
                                            <template v-slot:control>
                                                <div class="self-center text-center full-width">{{ detail.qty }}</div>
                                            </template>
                                        </q-field>
                                    </div>
                                    <div class="col-xs-8 col-sm-3 text-right text-subtitle2">
                                        <div>
                                            {{ detail.productPrice | currency }}
                                        </div>
                                        <div v-if="detail.discountValue"
                                             class="text-negative">
                                            -{{ detail.discountValue | currency }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xs-12 col-md-4 q-pb-md">
                                <div class="q-pa-md rounded-borders full-height bg-grey-2">
                                    <div class="row col">
                                        <div class="text-subtitle1 q-mb-sm">Order Summary</div>
                                    </div>

                                    <div class="row">
                                        <div class="col">
                                            Sub Total
                                        </div>
                                        <div class="col text-right">
                                            {{ getOrderData.subTotal | currency }}
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            Taxes
                                        </div>
                                        <div class="col text-right">
                                            {{ getOrderData.tax | currency }}
                                        </div>
                                    </div>
                                    <div class="row text-bold">
                                        <div class="col">
                                            Total
                                        </div>
                                        <div class="col text-right">
                                            {{ getOrderData.total | currency }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </q-card-section>
                </q-card>

                <order-receipt :order="getOrderData" />
            </div>
        </section>
        <q-inner-loading :showing="getOrderPending">
            <div>
                <q-spinner color="primary"
                           :thickness="2"
                           size="3em" />
            </div>
        </q-inner-loading>
        <q-page-sticky position="bottom-right" :offset="[18, 18]">
            <q-btn fab icon="mdi-arrow-left" color="primary" @click="$router.push('/myaccount/orders')" />
        </q-page-sticky>
    </div>
</template>
<script>
    import orderDetailsInfo from '@/components/OrderDetailsInfo'
    import orderReceipt from '@/components/OrderReceipt'
    import { mapState } from 'vuex'

    export default {
        name: 'order-details',
        props: {
            id: String,
        },
        components: {
            orderDetailsInfo,
            orderReceipt,
        },
        methods: {
            getOrder() {
                this.$store.dispatch('getOrder', this.id).then(() => {
                    if (!this.getOrderData) this.$router.push('/404').catch(err => { })
                })
            },
        },
        computed: {
            ...mapState([
                'getOrderPending',
                'getOrderData',
            ]),

        },
        created() {
            if (this.id)
                this.getOrder()
        },
    }
</script>
